import { ID, Response } from '../../../../_metronic/helpers'
import { ProductType } from '../products'

export type User = {
  id: ID
  name: string
  email: string
  role: string

  lastLoginDate?: string
  deleted: boolean
  dteCr: string
  dteUpd: string
  wrongPwdCount: number
  locked: boolean
  productTypes?: Array<ProductType>

  company?: {
      id: number
  }

  password?: string
  passwordConfirm?: string

  requireReview: boolean
}

export interface WebUser {
  id: number
  name: string    
  email: string
  role: string
  lastLoginDate: string

  password?: string
  productTypes?: Array<number>
  
  passwordConfirm?: string
  requireReview?: boolean
}

export const initUser:WebUser = {
  id: 0,
  name: '',
  email: '',
  role: '',
  lastLoginDate: '',
  productTypes: [],
  requireReview: false
}


export type UsersQueryResponse = Response<Array<WebUser>>

export const UserCAMSRoles = [    
  "CAMS Admin", 
  "CAMS Quotation Admin", 
  "CAMS Inspector", 
  "CAMS Second Reviewer", 
  "CAMS Program Manager", 
  "CAMS Committee Member",
  "CAMS Editor",    
];

export const UserDLMRoles = [    
  "DLM Admin", 
  "DLM Inspector",
  "DLM Program Manager", 
  "DLM Editor",    
];

export const UserAdminRoles = [    
  "User Admin",
  "Super Admin"
];


export const UserRoles = [    
  ...UserCAMSRoles,
  ...UserDLMRoles,
  ...UserAdminRoles    
];


